import { CheckCircleFilled } from "@ant-design/icons";
import { Result, Skeleton } from "antd";
import { useState } from "react";
import "../PrintCheckoutPage";
import { ChatService } from "../../../service/ChatService";
import "../PrintCheckoutPage.scss";
import { OtherProducts } from "./OtherProducts";
//import { MatchingDesigns } from "./MatchingDesigns";

export function Success({ order }: any) {
  const [loading] = useState(false);

  return (
    <div className={"print-success-page success"}>
      {loading && <Skeleton />}
      {!loading && order && (
        <>
          <Result
            status="success"
            icon={<CheckCircleFilled twoToneColor="#52c41a" width={100} height={100} />}
            title={<h2>Success!</h2>}
            subTitle={<p>Processing typically begins within 1 hour. <br />
              If you have any last-minute changes, contact our team right away <span className="intercom-link" onClick={ChatService.newMessage}>via chat</span>.</p>}
            extra={[
              // <NavLink to={env.dashboardPath + "/designs"}>
              //   <Button type={"primary"}>
              //     Back to Home
              //   </Button>
              // </NavLink>
            ]}
          />

          {/*<MatchingDesigns order={order} />*/}

          <OtherProducts page="success" />
        </>
      )}
    </div>
  );
}
